// React Dependencies
import React from 'react';

// External Dependencies
import PropTypes from 'prop-types';
import { TextField } from '@material-ui/core';

// Internal Dependencies
import MText from '../../../../../components/Common/MText';
import Colours from '../../../../../styles/colours';
import { IsEmpty } from '../../../../../common/checks';

const ReceiptField = ({ currentSelectionMode, selectionMode, handleSelectionModeChange, selectedItems, label, value }) => {
  const isActive = currentSelectionMode === selectionMode;
  const isActiveAndEmpty = isActive && IsEmpty(selectedItems);

  return (
    <div className="row mt-2 pl-2">
      <div className="col-12 pl-0 d-flex align-items-center">
        <MText
          size={12}
          colour={Colours.Black}
          style={{ textAlign: 'left', fontWeight: 500 }}
          text={label}
        />
      </div>
      <div className="col-12 pl-0 d-flex align-items-center">
        <TextField
          fullWidth
          name={selectionMode}
          size="small"
          variant="outlined"
          onClick={handleSelectionModeChange}
          value={isActiveAndEmpty ? 'Select text line in the receipt containing the value' : value}
          inputProps={{
            style: {
              fontWeight:      500,
              fontSize:        12,
              cursor:          'pointer',
              caretColor:      'transparent',
              backgroundColor: isActive ? Colours.White : Colours.Gray3,
              color:           isActiveAndEmpty ? Colours.Gray7 : Colours.Black,
              textAlign:       isActiveAndEmpty ? 'center' : 'left',
            },
          }}
        />
      </div>
    </div>
  );
};

ReceiptField.propTypes = {
  currentSelectionMode:      PropTypes.string,
  selectionMode:             PropTypes.string.isRequired,
  handleSelectionModeChange: PropTypes.func.isRequired,
  selectedItems:             PropTypes.arrayOf(PropTypes.number).isRequired,
  label:                     PropTypes.string.isRequired,
  value:                     PropTypes.string.isRequired,
};

ReceiptField.defaultProps = {
  currentSelectionMode: null,
};

export default ReceiptField;
